import { isDev } from '@libs/utils/helpers/isDev';
import { SHOffer } from '../services/sortingHat';
import { fillUrlParams } from './fillUrlParams';
import { getUrlCurrentApp } from './getUrlCurrentApp';
import { isLocal } from '@libs/utils/helpers/isLocal';
import { getApp } from '@libs/utils/helpers/getApplication';
import { addAutofillParam } from '@libs/utils/helpers/addAutofillParam';
import { UserType } from '../types';

type GetUrlParams = {
  offer: SHOffer;
  fireboltId?: string;
  user: UserType;
};
export async function getUrl({ offer, fireboltId, user }: GetUrlParams) {
  const { content, generalInfo } = offer;
  const { slug, links, full_funnel } = content;
  const { preApproved } = generalInfo;

  const url = offer?.matchMaker?.requestCardUrl || getUrlCurrentApp({ links, preApproved });
  if (!url) {
    console.error(`${slug} offer URL not found`);
    return '';
  }

  let completedUrl = await fillUrlParams({
    url,
    fireboltId,
    idUser: user?.id,
  });

  if (full_funnel) {
    completedUrl = addAutofillParam({
      productSlug: slug,
      url: completedUrl,
      user,
    });
  }

  const domain = getApp();
  if (isLocal() && full_funnel) {
    completedUrl = completedUrl.replace('www.', '').replace(`https://${domain}.com.br`, 'http://localhost:8000');
  } else if (isDev()) {
    completedUrl = completedUrl.replace(domain, `dev.${domain}`).replace('www.', '');
  }

  return completedUrl;
}
